import fonts from '@helpers/fonts';
import SimpleImage from '@stories/Components/SimpleImage/SimpleImage';
import styled from 'styled-components';
const Container = styled.section `
  display: block;
  margin: 0 0 28px;
`;
const Link = styled.a `
  display: block;
  color: currentColor;
  ${fonts.helvetica.regular};
  font-size: 15px;
  line-height: 1em;
  margin: 0 0 20px;
  text-decoration: none;
  text-underline-position: under;

  &:focus {
    outline: none;
  }

  &:focus,
  &:hover {
    text-decoration: underline;
  }
`;
const Image = styled(SimpleImage) `
  display: block;
  margin: 0 0 20px;
  max-width: min(50%, 135px);
`;
const CtaWrapper = styled.div `
  display: block;
`;
const AnnualReportCtaStyles = {
    Container,
    CtaWrapper,
    Image,
    Link,
};
export default AnnualReportCtaStyles;
